import FetchService from "../FetchService/CustomService";

const PERMISSION_API_ENDPOINTS = {
  GET_RECRUITER_PERMISSIONS: "/recruiter/teams/recruiter-permissions"
};

// Mock permissions data for development and testing
const MOCK_PERMISSIONS = {
  permissions: [
    { resource: "teams", action: "manage" },
    { resource: "company_wallet", action: "manage" },
    { resource: "company_profile", action: "view" }
  ]
};

class PermissionService {
  static async getUserPermissions() {
    try {
      const url =
        process.env.BASE_URL +
        PERMISSION_API_ENDPOINTS.GET_RECRUITER_PERMISSIONS;
      const response = await FetchService.getCall({ url });
      // console.log("response", response.data.data.permissions);
      return response.data.data;
    } catch (error) {
      return {
        permissions: [] // Return empty permissions on error
      };
    }
  }

  // Mock method for development and testing
  static getMockPermissions() {
    return new Promise(resolve => {
      // Add 1 second delay to simulate network latency
      setTimeout(() => {
        resolve(MOCK_PERMISSIONS);
      }, 2000);
    });
  }
}

export default PermissionService;
